import { IPromise, IQService } from "angular";
import { ServerUtility, vsName as ServerUtilityName } from "../../../../../records/server/serverUtility";

export interface ObjectIdentifier{
  type: "PartLocation" | "PartOrderItem" | "MachinePart" | "CheckedOutPart" | "VoidPartLocation";
  id: number;
}

export interface ObjectDetailResult{
  identifier: ObjectIdentifier;
  object: any;
}


export class ObjectDetailService{
  static $inject = ["$q", ServerUtilityName]
  constructor(private readonly $q: IQService,private readonly serverUtility: ServerUtility){}

  fetchObjects(objectIdentifiers: ObjectIdentifier[]): IPromise<ObjectDetailResult[]>{
    const promises = objectIdentifiers.map(oi => this.getObjectDetailPromise(oi))
    return this.$q.all(promises)
  }
  
  
  private getObjectDetailPromise(
    oi: ObjectIdentifier
  ): IPromise<ObjectDetailResult> {
  
    let promise: IPromise<any>
    
    switch (oi.type) {
      
      case "CheckedOutPart":
        promise = this.serverUtility.getById({
          url: "/api/user",
          id: oi.id
        })
        break
  
      case "MachinePart":
        promise = this.serverUtility.query({
          url: "/api/machines/MachineConfiguration",
          query: { MachineId: oi.id }
        })
        break
  
      case "PartLocation":
        promise = this.serverUtility.query({
          url: "/api/parts/properties",
          query: { Id: oi.id }
        })
        break
  
      case "PartOrderItem":
        promise = this.serverUtility.query({
          url: "/api/parts/orders",
          query: { Id: oi.id }
        })
        break
        
        case "VoidPartLocation":
          promise = this.$q.resolve({
            Id: oi.id,
            Shelf: "Void",
            Bin: "Void",
            
          })
          break
        

      default:
        return this.$q.reject(`Unknown object type : ${oi.type}`)
    }
  
  if (!promise) {
    return this.$q.reject(`Unsupported ObjectIdentifier type: ${oi.type}`)
  }

  return promise.then(r => ({
    identifier: oi,
    object: r
  }))
  }
  
}